module.exports = __webpack_public_path__ + "img/category-11.382ced37.svg";